<template>
  <div
    class="v-inline-tags-creator__wrapper"
    :class="{ [extraClass]: !!extraClass }"
  >
    <div class="tags-list__wrapper">
      <VTag
        v-for="tag in chosenTags"
        :key="tag.key"
        :_key="tag.key"
        :label="tag.label"
        :removeHandler="removeHandler"
        :withDelete="!_contactEditing"
      />
    </div>

    <div
      class="add"
      :class="{ ['no-tags']: chosenTags && !chosenTags.length }"
      v-if="!tagsOpened"
      @click="openTagsMenu"
    >
      Add
    </div>

    <div class="dropdown-select__outer">
      <VDropDownSelect
        v-if="tagsOpened"
        :items="_tags"
        :chosenTagNames="chosenTags && chosenTags.map(item => item.label)"
        @add="onAddTag"
        @select="onSelectTag"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapGetters } from "vuex";

// components
import VDropDownSelect from "@/components/VDropDownSelect";
import VTag from "@/components/VTag";

import withToasted from "@/mixins/withToasted";
import { convertTagsToSelectListFormat } from "@/utils/util";

export default Vue.component("VInlineTagsCreator", {
  props: {
    // initial tags
    tagsList: VueTypes.array,
    minItemsCount: VueTypes.number.def(0),
    extraClass: VueTypes.string.def("")
  },

  components: {
    VDropDownSelect,
    VTag
  },

  mixins: [withToasted],

  data() {
    return {
      tagsOpened: false,
      chosenTags: this.tagsMap()
    };
  },

  computed: {
    _tags() {
      if (!this.chosenTags) {
        return [];
      }

      const chosenTagsKeys = this.chosenTags.map(item => {
        return item.key;
      });

      return convertTagsToSelectListFormat(this.storeTags).filter(
        item => !chosenTagsKeys.includes(item.key)
      );
    },

    _contactEditing() {
      return this.contactEditing;
    },

    ...mapGetters("contacts", {
      storeTags: "tags",
      contactEditing: "contactEditing"
    })
  },

  methods: {
    tagsMap() {
      return [
        ...this.tagsList
          .filter(item => item && item)
          .map(item => {
            return {
              key: item.id,
              value: item.name,
              label: item.name
            };
          })
      ];
    },

    _triggerEmitStatus() {
      this.$emit("statusChange", !!this.chosenTags.length);
    },

    onAddTag(tag) {
      const { key, label, value } = tag;
      this.onSelectTag(key, value, label);
    },

    onSelectTag(key, value, label) {
      this.chosenTags = [
        ...this.chosenTags,
        {
          key,
          value,
          label
        }
      ];
      this._triggerEmitStatus();
      this.$emit("select", { key, value, label });
    },

    removeHandler(e, key) {
      if (this.minItemsCount < this.chosenTags.length) {
        e.stopPropagation();
        this.chosenTags = this.chosenTags.filter(item => item.key !== key);
        this._triggerEmitStatus();
        this.$emit("remove", { key });
      } else {
        return this.errorToast("Tags field cannot be empty!");
      }
    },

    closeTagsMenu() {
      if (this.tagsOpened) {
        this.tagsOpened = false;
      }
    },

    openTagsMenu(e) {
      e.stopPropagation();
      this.tagsOpened = !this.tagsOpened;
    }
  },

  created() {
    document.addEventListener("click", this.closeTagsMenu);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closeTagsMenu);
  },

  watch: {
    tagsList() {
      this.chosenTags = this.tagsMap();
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-inline-tags-creator";

.#{$ns} {
  &__wrapper {
    width: 100%;
    overflow: visible;

    .add {
      font-size: 14px;
      cursor: pointer;
      margin-top: 10px;
      color: $default-color;
      font-family: Lato-Regular, Arial, sans-serif;

      &.no-tags {
        margin-top: 0;
      }

      &:hover {
        color: $primary-color;
      }
    }

    .tags-list__wrapper {
      display: flex;
      flex-wrap: wrap;
    }

    .dropdown-select__outer {
      width: 100%;
    }
  }
}
</style>
